import { gql } from '@apollo/client';

export const GET_USER_BY_AUTH = gql`
  query userAccountByAuth {
    userByAuth {
      id
      lobEmployeeId
      firstName
      lastName
      middleName
      email
      bun
      isActive
      defaultProjectId
      defaultProject {
        id
        name
        jobNumber
        subJobNumber
      }
      employee {
        id
        lobEmployeeId
        imageUrl
      }
      permissionScopes {
        id
        permission {
          id
          name
          description
        }
        scope {
          id
          name
        }
      }
      projects {
        id
        jobNumber
        name
        subJobNumber
      }
    }
  }
`;
export const UPDATE_USER_DEFAULT_PROJECT = gql`
  mutation updateUserDefaultProject($updateUserDefaultProjectInput: UpdateUserDefaultProjectInput!) {
    updateUserDefaultProject(updateUserDefaultProjectInput: $updateUserDefaultProjectInput) {
      user {
        id
        defaultProjectId
        defaultProject {
          id
          name
          jobNumber
          subJobNumber
        }
      }
    }
  }
`;

export const UPDATE_USER_ACCOUNT_PROJECT = gql`
  mutation updateUserAccountProject($updateUserAccountProjectInput: UpdateUserAccountProjectInput!) {
    updateUserAccountProject(updateUserAccountProjectInput: $updateUserAccountProjectInput) {
      userAccountProject {
        id
        projectId
        userAccountId
        isFavorite
        updatedTime
        updatedBy
      }
      errors
    }
  }
`;

export const GET_USER_ACCOUNT_PROJECTS = gql`
  query SearchUserAccountProjects($searchInput: SearchInput) {
    searchUserAccountProjects(searchInput: $searchInput) {
      items {
        id
        projectId
        userAccountId
        isFavorite
        project {
          id
          name
          jobNumber
          subJobNumber
          logo
        }
      }
    }
  }
`;
